import React, {
  FC, useEffect, useState,
} from 'react';
import Header from '../../../../Common/Header';
import { getCabId, getWindowWidth } from '../../../../../../lib/utils/utils';
import SquadRegularText from '../../../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../../../components/Text/PingFangRegularText';
import BackgroundImage from '../../../../../../components/BackgroundImage';
import Title from './Title';
import Tabs from './Tabs';
import ColumnCenter from '../../../../../../components/Layout/ColumnCenter';
import SquadSemiBoldText from '../../../../../../components/Text/SquadSemiBoldText';
import PingFangMediumText from '../../../../../../components/Text/PingFangMediumText';
import SearchInput from './SearchInput';
import SearchName from './SearchName';
import SearchPhone from './SearchPhone';
import { updateFoodifoxData } from '../../../../../../lib/axios/FoodifoxDataAPI';
import NoFreeBoxModal from '../../../../Common/NoFreeBoxModal';
import { addSystemLog } from '../../../../../../lib/SystemLogUtils';
import { Box } from '../../../../../../lib/types';
import CabSizeSelect from '../CabSizeSelect';
import OpenBoxSuccess from '../../OpenBox/Code/OpenBoxSuccess';

const SearchUser: FC<Props> = ({
  cabId32Str,
  selectedPlatform,
  isEnglish,
  setIsEnglish,
  setShowLoading,
  driverId,
  smallCabId,
  largeCabId,
  onClose,
  setSelectedPlatform,
}) => {
  const [checkHasFreeBox, { loading: checkLoading }] = updateFoodifoxData<{ cabId: number; hasFreeBox: boolean }[]>('/foxH5Home/checkHasFreeBox');
  const [renBoxLazy, { loading: rentLoading }] = updateFoodifoxData<{boxNumber: string; openCode: number; orderId: number; cabSizeType: string; openBoxes: Box[]}>('/foxH5RentBox/rentBoxNoPhone');
  const [tabIndex, setTabIndex] = useState<number>(0);
  const [searchKey, setSearchKey] = useState<string>();
  const [showNoFreeBoxModal, setShowNoFreeBoxModal] = useState<boolean>();
  const [showCabSizeSelect, setShowCabSizeSelect] = useState<boolean>(false);
  // 收件人信息
  const [parcelUserInfo, setParcelUserInfo] = useState<{ searchType: string; userId: number; userName: string; phoneNumber: string }>();
  // 柜子柜门空闲状态集合
  const [cabFreeStatus, setCabFreeStatus] = useState<{ cabId: number; hasFreeBox: boolean }[]>();
  const [orderInfo, setOrderInfo] = useState<{ pickupCode: string; orderId: number; openBoxes: Box[] }>();

  useEffect(() => {
    setShowLoading(rentLoading || checkLoading);
    return () => {
      setShowLoading(false);
    };
  }, [rentLoading, checkLoading]);

  useEffect(() => {
    setSearchKey(undefined);
  }, [tabIndex]);

  /**
   * 租用柜门
   */
  const rentBox = (searchType: string, userId: number, userName: string) => {
    if (selectedPlatform == null) {
      return;
    }
    if (driverId == null) {
      return;
    }
    renBoxLazy({
      param: {
        cabId: cabId32Str,
        driverId,
        platform: selectedPlatform,
        parcelUserId: userId,
        parcelUserName: userName,
        searchUserType: searchType,
      },
      onError() {
        setShowNoFreeBoxModal(true);
      },
      onCompleted(rentData) {
        const { openCode, orderId, openBoxes } = rentData;
        setOrderInfo({ pickupCode: openCode + '', orderId, openBoxes });
        addSystemLog(getCabId(cabId32Str), '', selectedPlatform + '', '骑手ID：' + driverId + '，租用柜门：' + JSON.stringify(openBoxes.map((box) => box.boxNumber)) + '，取餐码：' + openCode);
      },
    });
  };

  /**
   * 选择确认用户后
   * @param searchType
   * @param userId
   * @param userName
   * @param phoneNumber
   */
  const selectedUserCallback = (searchType: string, userId: number, userName: string, phoneNumber: string) => {
    setParcelUserInfo({ userId, userName, searchType, phoneNumber });
    checkHasFreeBox({
      param: {
        cabId: cabId32Str,
      },
      onError() {
        setShowNoFreeBoxModal(true);
      },
      onCompleted(data) {
        if (smallCabId && largeCabId) {
          setCabFreeStatus(data);
          setShowCabSizeSelect(true);
        }
        else {
          rentBox(searchType, userId, userName);
        }
      },
    });
  };

  return (
    <>
      {
        (!showCabSizeSelect && !orderInfo) && (
          <BackgroundImage>
            {
              showNoFreeBoxModal && (
                <NoFreeBoxModal
                  onClose={() => {
                    setShowNoFreeBoxModal(false);
                    setSelectedPlatform(undefined);
                  }}
                  isEnglish={isEnglish}
                />
              )
            }
            {/* 头部 */}
            <Header
              isEnglish={isEnglish}
              setIsEnglish={setIsEnglish}
              style={{ marginTop: 20 }}
              supportIsOnlyCall={true}
              cabId32Str={cabId32Str}
            />

            {/* 标题 */}
            <Title onClose={onClose} isEnglish={isEnglish} />
            {/* Tabs */}
            <Tabs
              isEnglish={isEnglish}
              tabIndex={tabIndex}
              setTabIndex={setTabIndex}
            />

            <ColumnCenter style={{ marginTop: 15 }}>
              {
                isEnglish ? (
                  <SquadSemiBoldText fontSize={15} lineHeight={19} opacity={0.5}>
                    Please note:
                  </SquadSemiBoldText>
                ) : (
                  <PingFangMediumText fontSize={15} lineHeight={19} opacity={0.5}>
                    请注意：
                  </PingFangMediumText>
                )
              }
              {
                isEnglish ? (
                  <SquadRegularText fontSize={15} lineHeight={19} opacity={0.5}>
                    You can only deliver food to registered users.
                  </SquadRegularText>
                ) : (
                  <PingFangRegularText fontSize={15} lineHeight={22} opacity={0.5}>
                    你只能向已注册用户配送食物。
                  </PingFangRegularText>
                )
              }

              {/* 搜索框 */}
              <SearchInput
                value={searchKey}
                onChange={setSearchKey}
                placeholder={tabIndex === 0 ? (isEnglish ? 'Search recipient’s name here' : '在此处搜索收件人姓名') : (isEnglish ? 'Search recipient’s phone number here' : '收件人的电话号码。例如：410100100')}
              />

              {
                tabIndex === 0 && (
                  <>
                    <SearchName
                      isEnglish={isEnglish}
                      cabId={getCabId(cabId32Str)}
                      searchText={searchKey}
                      selectUserCallback={(userId: number, userName: string, phoneNumber) => {
                        selectedUserCallback('name', userId, userName, phoneNumber);
                      }}
                    />

                    <ColumnCenter style={{ marginTop: 36, marginBottom: 50 }}>
                      {
                        isEnglish ? (
                          <SquadSemiBoldText fontSize={15} lineHeight={19}>
                            Need help finding the name?
                          </SquadSemiBoldText>
                        ) : (
                          <PingFangMediumText fontSize={15} lineHeight={19}>
                            在哪找到收件人姓名？
                          </PingFangMediumText>
                        )
                      }
                      {
                        isEnglish ? (
                          <SquadRegularText fontSize={15} lineHeight={19} maxWidth={getWindowWidth() - 50}>
                            The recipient’s name can either be found on on the <SquadSemiBoldText color={'#00B595'} isSpan={true}>delivery docket attached to an order</SquadSemiBoldText> or you can locate it <SquadSemiBoldText color={'#00B595'} isSpan={true}>on your delivery application.</SquadSemiBoldText>
                          </SquadRegularText>
                        ) : (
                          <PingFangRegularText fontSize={15} lineHeight={22} maxWidth={getWindowWidth() - 50}>
                            您可以在"<SquadSemiBoldText color={'#00B595'} isSpan={true}>外卖上的收据订单</SquadSemiBoldText>"上找到收件人的姓名，或者您也可以在" <SquadSemiBoldText color={'#00B595'} isSpan={true}>外卖平台app</SquadSemiBoldText>"上找到。
                          </PingFangRegularText>
                        )
                      }
                    </ColumnCenter>
                  </>
                )
              }
              {
                tabIndex === 1 && (
                  <>
                    <SearchPhone
                      isEnglish={isEnglish}
                      cabId={getCabId(cabId32Str)}
                      searchText={searchKey}
                      selectUserCallback={(userId: number, userName: string, phoneNumber) => {
                        selectedUserCallback('phone', userId, userName, phoneNumber);
                      }}
                    />

                    <ColumnCenter style={{ marginTop: 36, marginBottom: 50 }}>
                      {
                        isEnglish ? (
                          <SquadSemiBoldText fontSize={15} lineHeight={19}>
                            Need help finding the phone number?
                          </SquadSemiBoldText>
                        ) : (
                          <PingFangMediumText fontSize={15} lineHeight={19}>
                            在哪找到收件人电话？
                          </PingFangMediumText>
                        )
                      }
                      {
                        isEnglish ? (
                          <SquadRegularText fontSize={15} lineHeight={19} maxWidth={getWindowWidth() - 50}>
                            The recipient’s phone number can either be found on on the <SquadSemiBoldText color={'#00B595'} isSpan={true}>delivery docket attached to an order</SquadSemiBoldText> or you can locate it <SquadSemiBoldText color={'#00B595'} isSpan={true}>on your delivery application.</SquadSemiBoldText>
                          </SquadRegularText>
                        ) : (
                          <PingFangRegularText fontSize={15} lineHeight={22} maxWidth={getWindowWidth() - 50}>
                            您可以在"<SquadSemiBoldText color={'#00B595'} isSpan={true}>外卖上的收据订单</SquadSemiBoldText>"上找到收件人电话，或者您也可以在"<SquadSemiBoldText color={'#00B595'} isSpan={true}>外卖平台app</SquadSemiBoldText>"上找到。
                          </PingFangRegularText>
                        )
                      }
                    </ColumnCenter>
                  </>
                )
              }
            </ColumnCenter>
          </BackgroundImage>
        )
      }
      {
        showCabSizeSelect && parcelUserInfo && cabFreeStatus && smallCabId && largeCabId && (
          <CabSizeSelect
            cabId32Str={cabId32Str}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setShowLoading={setShowLoading}
            platform={selectedPlatform}
            driverId={driverId}
            smallCabId={smallCabId}
            largeCabId={largeCabId}
            cabFreeStatus={cabFreeStatus}
            parcelUserId={parcelUserInfo.userId}
            parcelUserName={parcelUserInfo.userName}
            parcelPhoneNumber={parcelUserInfo.phoneNumber}
            searchUserType={parcelUserInfo.searchType}
            onClose={() => {
              setParcelUserInfo(undefined);
              setShowCabSizeSelect(false);
              setSelectedPlatform(undefined);
            }}
          />
        )
      }
      {
        orderInfo && parcelUserInfo && (
          <OpenBoxSuccess
            cabId32Str={cabId32Str}
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            setShowLoading={setShowLoading}
            driverId={driverId}
            pickupCode={orderInfo.pickupCode}
            orderId={orderInfo.orderId}
            platform={selectedPlatform}
            onClose={onClose}
            openedBoxes={orderInfo.openBoxes}
            parcelPhoneNumber={parcelUserInfo.phoneNumber}
          />
        )
      }
    </>
  );
};

export interface Props {
  cabId32Str: string;
  selectedPlatform: number;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setShowLoading: (isShow: boolean) => void;
  driverId: number;
  // 大小柜组合时，小柜柜子ID和大柜柜子ID
  smallCabId?: number;
  largeCabId?: number;
  onClose: () => void;
  setSelectedPlatform: (platform: number | undefined) => void;
}

export default SearchUser;
